import { PropsWithChildren, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import styled from 'styled-components';
import { Flex } from 'reflexbox';

import { Popover, SidebarLayout } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

import Sidebar from '../navigation/Sidebar';
import Ribbon from 'navigation/Ribbon';
import Menu from 'navigation/Menu';
import HelicopterProvider from 'navigation/HelicopterContext';
import { useWorkspace } from 'packages/kakapo-ui-services/hooks/useWorkspace';
import useViewerRoles from 'packages/kakapo-ui-application/hooks/useUserRoles';
import TrialExpired from 'onboarding/TrialExpired';
import BillingSuccess from 'onboarding/BillingSuccess';
import { Route, Switch } from '@treams/treams-routes';
import Billing from 'billing/Billing';
import ExpirationBanner from 'layout/components/ExpirationBanner';

const Container = styled(Flex)`
	flex-direction: column;
	justify-content: stretch;
	min-height: 100vh;
	font-family: 'Source Sans Pro', sans-serif;
`;

// eslint-disable-next-line @typescript-eslint/ban-types
export default function Layout(props: PropsWithChildren<{}>) {
	const workspace = useWorkspace();
	const { data } = graphql.useViewerWorkspacePlanQuery();

	const query = graphql.useViewerWorkspacePlanQuery();
	const roles = useViewerRoles();

	const [sidebar, setSidebar] = useState(false);

	const location = useLocation();

	useEffect(() => setSidebar(false), [location.key]);

	const isExpired = query.data?.viewer.workspace.isExpired ?? false;

	if (workspace.id === 'launch') {
		return (
			<>
				<Ribbon />
				<Menu />
				{props.children}
			</>
		);
	}

	const isTrialEnvironment = data?.viewer.workspace.plans.every((plan) => plan.isTrial);

	return (
		<Switch>
			<Route path="/settings/billing/success">
				<BillingSuccess />
			</Route>
			<Route>
				<Container>
					{isTrialEnvironment && <ExpirationBanner />}
					<HelicopterProvider>
						<SidebarLayout
							isSidebarOpen={sidebar}
							sidebar={<Sidebar onClose={!sidebar ? undefined : () => setSidebar(false)} />}
						>
							<Ribbon />
							<Menu onOpen={sidebar ? undefined : () => setSidebar(true)} />
							{props.children}
						</SidebarLayout>
					</HelicopterProvider>
				</Container>

				{isExpired && !roles.loading && (
					<Popover center visible>
						{roles.isWorkspaceSuperuser ? <Billing modal /> : <TrialExpired employee modal />}
					</Popover>
				)}
			</Route>
		</Switch>
	);
}
